"use strict";

(function ($) {
  if (navigator.platform.match('Mac') !== null) {
    document.body.classList.add('mac');
  }

  // initiate fancybox for all lightbox rels
  $('.lightbox, a[rel^="lightbox"]').fancybox({
    prevEffect: 'none',
    nextEffect: 'none',
    closeBtn: true,
    arrows: true,
    nextClick: true,
    helpers: {
      thumbs: {
        width: 50,
        height: 50
      },
      overlay: {
        locked: false
      }
    }
  });

  // Mobile Table
  $('table.table-mobile').each(function () {
    var labels = [];
    $(this).find('th').each(function (headIndex) {
      labels[headIndex] = $(this).text();
    });
    $(this).find('tr').each(function () {
      $(this).children('td').each(function (cellIndex) {
        $(this).attr('data-content', labels[cellIndex]);
      });
    });
  });

  //toggle accordeon
  $('.accordeon').on('show.bs.collapse', function (e) {
    $(e.target).prev('.panel-heading').addClass('open');
  }).on('hide.bs.collapse', function (e) {
    $(e.target).prev('.panel-heading').removeClass('open');
  });

  // language selection
  //---------------------
  if (is.touchDevice()) {
    $('header .current-language').click(function () {
      $('header .languagenav').toggleClass('open');
    });
  } else {
    $('header .languagenav').hover(function () {
      $(this).toggleClass('open');
    });
  }
  $('.current-language').html($('.languagenav ul li.active').html());
  $('a.disabled').click(function (e) {
    e.preventDefault();
  });

  // wrap tables responsive
  $("#main .csc-default table").not('.table-mobile').wrap('<div class="table-responsive"></div>');
  var filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
  var baseHref = '';
  if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');
  $('a').click(function (event) {
    var el = jQuery(this);
    var track = true;
    var href = typeof el.attr('href') != 'undefined' ? el.attr('href') : "";
    var isThisDomain = href.match(document.domain.split('.').reverse()[1] + '.' + document.domain.split('.').reverse()[0]);
    if (!href.match(/^javascript:/i)) {
      var elEv = [];
      elEv.value = 0, elEv.non_i = false;
      if (href.match(/^mailto\:/i)) {
        elEv.category = "email";
        elEv.action = "click";
        elEv.label = href.replace(/^mailto\:/i, '');
        elEv.loc = href;
      } else if (href.match(filetypes)) {
        var extension = /[.]/.exec(href) ? /[^.]+$/.exec(href) : undefined;
        elEv.category = "download";
        elEv.action = "click-" + extension[0];
        elEv.label = href.replace(/ /g, "-");
        elEv.loc = baseHref + href;
      } else if (href.match(/^https?\:/i) && !isThisDomain) {
        elEv.category = "external";
        elEv.action = "click";
        elEv.label = href.replace(/^https?\:\/\//i, '');
        elEv.non_i = true;
        elEv.loc = href;
      } else if (href.match(/^tel\:/i)) {
        elEv.category = "telephone";
        elEv.action = "click";
        elEv.label = href.replace(/^tel\:/i, '');
        elEv.loc = href;
      } else track = false;
      if (track) {
        var r = ga('send', 'event', elEv.category.toLowerCase(), elEv.action.toLowerCase(), elEv.label.toLowerCase());
        console.log(r);
        console.log('pushed data');
        if (el.attr('target') == undefined || el.attr('target').toLowerCase() != '_blank') {
          setTimeout(function () {
            location.href = elEv.loc;
          }, 400);
          return false;
        }
      }
    }
  });
})(jQuery);
"use strict";

/*
 * Base.js
 * Copyright 2013-2016 Agentur Frontal AG
 * http://frontal.ch
 */

/*global $*/

$(document).ready(function () {
  'use strict';

  // Mobile Table
  $('table.table-mobile, table.table-mobile-striped').each(function () {
    var labels = [];
    $(this).find('th').each(function (headIndex) {
      labels[headIndex] = $(this).text();
    });
    $(this).find('tr').each(function () {
      $(this).children('td').each(function (cellIndex) {
        $(this).attr('data-content', labels[cellIndex]);
      });
    });
  });

  // Triggers the 'collapsed' class in the accordeon
  // Doesn't get change as should due to T3 adding the whole path in front of #-anchors
  $('.accordeon .panel-heading a').click(function () {
    $(this).toggleClass('collapsed');
  });
});